"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _mobxReact = require("mobx-react");

var _ = require("../..");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

require("./HorizontalStepper.css");

var _styles = {
  "horizontal-stepper": "HorizontalStepper__horizontal-stepper___2fnXe",
  "step-container": "HorizontalStepper__step-container___3z84s",
  "active": "HorizontalStepper__active___1mVXl",
  "complete": "HorizontalStepper__complete___2B7WY",
  "step-number": "HorizontalStepper__step-number___1JZWY",
  "step-text": "HorizontalStepper__step-text___ZgT4Q",
  "icon": "HorizontalStepper__icon___tmYWa"
};

const styles = _bind.default.bind(_styles);

const HorizontalStepper = (0, _mobxReact.observer)(({
  className,
  dataTestId,
  steps,
  currentStep
}) => {
  const composed_classname = (0, _bind.default)(styles('horizontal-stepper'), className);
  return _react.default.createElement(_.Flex, {
    direction: 'row',
    dataTestId: dataTestId,
    alignItems: 'flex-start',
    className: composed_classname
  }, steps.map((step, idx) => {
    const active = idx === currentStep - 1;
    const stepComplete = currentStep > 0 && idx < currentStep - 1;
    const step_classname = (0, _bind.default)(styles('step-container', {
      active,
      complete: stepComplete
    }));
    return _react.default.createElement(_.Flex, {
      key: idx,
      dataTestId: dataTestId && `${dataTestId}-step-container`,
      gap: 8,
      direction: 'row',
      alignItems: 'center',
      padding: 0,
      className: step_classname
    }, stepComplete ? _react.default.createElement(_.Icon, {
      name: _.IconEnum.check,
      size: 15,
      color: _.Color.green._50,
      className: styles('icon')
    }) : _react.default.createElement(_.Text, {
      size: 13,
      variant: 'medium',
      textAlign: 'center',
      color: active ? _.Color.neutral.white : _.Color.neutral._80,
      className: styles('step-number', {
        active
      })
    }, idx + 1), _react.default.createElement(_.Text, {
      size: 13,
      variant: 'medium',
      textAlign: 'center',
      className: styles('step-text', {
        active
      })
    }, step));
  }));
});
var _default = HorizontalStepper;
exports.default = _default;